/**
 * Boolean value which tells if environment is production
 */
export const isProductionEnvironment = document.getElementById("production-environtment").getAttribute("data-environment") === "True";
/**
 * Array of locales where rating button is being displayed
 */
export const locale = ["ru-RU"];

/**
 * BazaarVoice passKey used for production
 */
export const passKeyProduction =
    "cayvhjrn0MTIZiunrAQ5j3Guf8m0Eg99UFjKxQ003WHoA";

/**
 * BazaarVoice passKey used for staging
 */
export const passKeyStaging = "caDPdjI7PumrgGGLeT6hP3l3qTrGSUoqX5XCQ26acC8w8";

/**
 * BazaarVoice passKey based on environment mode
 */
export const passKey =
isProductionEnvironment ? passKeyProduction : passKeyStaging;

/**
 * Company name required in terms view
 */
export const companyName = "Nioxin";

/**
 * Age required in terms view
 */
export const requiredAge = "18";

/**
 * Staginng BV Api
 */
export const bvApiUrlStage = "https://stg.api.bazaarvoice.com/data/submitreview.json";

/**
 * Production BV Api
 */
export const bvApiUrlProduction = "https://api.bazaarvoice.com/data/submitreview.json";

/**
 * BV Api based on environment
 */
export const bvApiUrl = isProductionEnvironment ? bvApiUrlProduction : bvApiUrlStage;